import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { colors } from '../../constants/styleConstants';
import SocialLinks from '../SocialLinks';

const useStyles = makeStyles()({
  socialShare: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 15,
  },
  socialShareText: {
    fontSize: '13px',
    color: colors.subTitle,
    marginRight: 5,
  },
});

const SocialShareBlock = ({ socialLinks, className }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={classes.socialShare}>
      <SocialLinks socialLinks={socialLinks} iconClass={className} />
    </div>
  );
};

SocialShareBlock.propTypes = {
  socialLinks: PropTypes.array.isRequired,
  className: PropTypes.string,
};

SocialShareBlock.defaultProps = {
  className: '',
};

export default SocialShareBlock;
